import { useQuery } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { Pyramide } from '@teetsh/app/src/types/pyramide';

export const PYRAMIDE_KEY = 'pyramideData';

export default function usePyramide() {
  const { schoolyear, school } = useSchoolSchoolyear();
  return useQuery({
    queryKey: [schoolyear.id, school.id, PYRAMIDE_KEY],
    queryFn: () =>
      request(`/schoolyear/${schoolyear.id}/school/${school.id}/pyramide`, {
        method: 'GET',
      }).then<Pyramide>(res => res),
  });
}
